/**
 * Names of all script functions.
 *
 * @module
 */

/** Script function type for `0x1::managed_coin::burn`. */
export const burn = "0x1::managed_coin::burn" as const;

/** Script function type for `0x1::managed_coin::initialize`. */
export const initialize = "0x1::managed_coin::initialize" as const;

/** Script function type for `0x1::managed_coin::mint`. */
export const mint = "0x1::managed_coin::mint" as const;

/** Script function type for `0x1::managed_coin::register`. */
export const register = "0x1::managed_coin::register" as const;
